import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Breadcrumb } from 'antd';
import { DemoControls } from './demoControls';
import { useNavigationStore } from 'src/hooks/navigation';

export const HeaderDemoButtons = () => {};

export const Header = () => {
  const [pageTitle, setPageTitle] = useState('');
  const { title, breadcrumb } = useNavigationStore();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    let titleObject = {
      '/appointments': 'Appointments',
      '/current-encounters': 'Current Encounter',
      '/encounters': 'Encounters',
      '/encountersbin': 'Aura Bin',
      '/encounter': 'Aura AI',
      '/settings': 'Settings',
      '/superadmin': 'Super admin',
      '/csvupload': 'CSV Upload',
      '/superadmin/officepracticum': 'Office Practicum Settings',
      '/op-settings': 'Office Practicum Settings',
      '/open-dr-settings': 'OpenDr Settings',
      '/memory': 'Memory',
      '/templates': 'Templates',
      '/prompts': 'Prompts',
      '/ai': 'AI Configurations',
      '/formconditions': 'Form Conditions',
      '/autotemplate': 'Auto Template',
      '/frontdesk/calls': 'Calls',
      '/agents': 'Agents',
    };
    setPageTitle(
      `${titleObject[location?.pathname as keyof typeof titleObject] || ''} `
    );
  }, [location]);

  const renderPageHeader = () => {
    let titleJsx = null;
    let breadcrumbJsx = null;

    if (title) {
      if (typeof title === 'string') {
        titleJsx = <div className="font-semibold text-lg">{title}</div>;
      } else {
        titleJsx = title;
      }
    }

    if (breadcrumb?.length) {
      breadcrumbJsx = (
        <Breadcrumb
          items={breadcrumb.map(
            ({ onClick, href, icon, title, navigateOptions }) => ({
              title: (
                <div
                  className={[
                    'flex items-center gap-1 h-[22px]',
                    (onClick || href) &&
                      'cursor-pointer text-primary hover:underline',
                  ]
                    .filter(Boolean)
                    .join(' ')}
                  onClick={(e) => {
                    onClick?.(e);
                    if (href) {
                      navigate(href, navigateOptions);
                    }
                  }}
                >
                  {icon}
                  {title}
                </div>
              ),
            })
          )}
        />
      );
    }

    if (pageTitle && !titleJsx && !breadcrumbJsx) {
      if (typeof pageTitle === 'string') {
        titleJsx = <div className="font-semibold text-lg">{pageTitle}</div>;
      } else {
        titleJsx = pageTitle;
      }
    }
    return titleJsx || breadcrumbJsx ? (
      <div className="flex flex-col">
        {breadcrumbJsx}
        {titleJsx}
      </div>
    ) : null;
  };

  return (
    <div className="h-[60px] flex-shrink-0 shadow-sm px-4 py-2">
      <div className="flex items-center justify-between w-full h-full">
        <div className="flex items-center">{renderPageHeader()}</div>
        <div className="flex items-center">
          <DemoControls />
        </div>
      </div>
    </div>
  );
};
